<template>
  <!--
      	作者：kmdshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置
      -->
  <div v-loading="loading">
    <el-tabs size="small" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
      <el-tab-pane label="升级设置" name="upgrade"></el-tab-pane>
    </el-tabs>

    <!--基础设置-->
    <Basic v-if="activeName == 'basic'"></Basic>
    <!--升级设置-->
    <Upgrade v-if="activeName == 'upgrade'"></Upgrade>
  </div>
</template>
<script>
import CardApi from '@/api/card.js';

import Basic from './part/Basic';

import Upgrade from './part/upgrade/upgrade';

export default {
  components: {
    /*编辑组件*/
    Basic,
    Upgrade
  },
  data() {
    return {
      /*是否正在加载*/
      loading:true,
      /*当前选中*/
      activeName: '',
      /*数据对象*/
      settingData:{}
    };
  },
  created() {
    
    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    this.getData();

  },
  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      self.loading=false;
      self.activeName='basic';
    },

    handleClick(e) {
      this.activeName = e.name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/card/cardauth/index.vue